import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "aa2bae1692e044609656a1a46c8c80a4",
  title: "Azerbaijan Airlines",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.ico"],
  logo: "/assets/images/logo.png",
  domain: "tickets.miles.azal.az",
  detectLocale: true,
  detectCurrency: true,
  loyalty: {
    code: "AZAL_MILES",
    text: {
      "en-US": {
        name: "AZAL Miles",
        unit: { singular: "mile", plural: "miles" },
        fields: {
          membership_number: {
            label: "AZAL Miles membership number",
            helpText: "Add your membership number to receive your miles.",
          },
        },
      },
    },
  },
};
